import { Component, OnDestroy, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import { CupraModelVersionModel } from '../../../models/cupramodelversion';
import { SeatFileFidelizationProductsCupraModel } from 'src/app/models/SeatFileFidelizationProductsCupra';
import { BudgetBuilderService } from 'src/app/services/budgetbuilder.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CupraBudgetService } from 'src/app/services/budget.service';
import { Options } from 'ng5-slider';
import { ToastrService } from 'ngx-toastr';
import { Select2OptionData } from 'ng-select2';
import { SharedService } from 'src/app/services/shared.service';
import { CupraBudgetModel } from '../../../models/cuprabudget';
import { ActivatedRoute, Router } from '@angular/router';



@Component({
  templateUrl: './specifications.component.html',
  styleUrls: ['./specifications.component.scss']
})

export class SpecificationsComponent implements OnInit {

  dataform: FormGroup;
  submitted = 0;
  searchModel: SeatFileFidelizationProductsCupraModel;
  newBudget: CupraBudgetModel;
  pathServer = environment.urlServer;
  public provinces: Array<Select2OptionData>;
  valueKm: number = 0;
  options: Options = {
    floor: 1000,
    ceil: 300000,
    step: 1000,
    // ticksTooltip: (v: number): string => {
    //   return 'Tooltip for ' + v;
    // }
  };
  idBudget: string;
  showProvince = false;
  value = 0;
  handleMinus() {
    this.value--;
    //this value only positive number typescript
    if (this.value < 0) {
      this.value = 0;
    }
  }
  handlePlus() {
    this.value++;
  }

  constructor(
    private budgetBuilderService: BudgetBuilderService,
    private sharedService: SharedService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private budgetService: CupraBudgetService) { }



  ngOnInit() {

    this.idBudget = this.route.snapshot.paramMap.get('id');
    this.loadData();

    this.dataform = new FormGroup({
      Km: new FormControl(null, [Validators.max(150000)]),
      Months: new FormControl(null, [Validators.max(120)]),
      IdBudget: new FormControl(null),
      IdStatus: new FormControl(null),
      IdModel: new FormControl(null),
      IdVersion: new FormControl(null),
      IdDistributor: new FormControl(null),
      IdProvince: new FormControl(null, [Validators.required]),
      BudgetCode: new FormControl(null),
      Matricula: new FormControl(null),
      Bastidor: new FormControl(null),
      ModelVersion: new FormControl(null),
      Tax: new FormControl(null),
      Workforce: new FormControl(null),
      Email: new FormControl(null),
      Distributor: new FormControl(null),
      DistributorAddress: new FormControl(null),
      DistributorCity: new FormControl(null),
      DistributorCp: new FormControl(null),
      DistributorPhone: new FormControl(null),
      CcEmrSubscribed: new FormControl(null),
      HasMaintenance: new FormControl(null),
      DiscountA: new FormControl(null),
      DiscountB: new FormControl(null),
      DiscountC: new FormControl(null),
      CupraCarePrice: new FormControl(null),
      FirstTime: new FormControl(null),
    });

    this.budgetService.get(this.idBudget).subscribe(res => {
      this.newBudget = res;
      this.valueKm = res.Km;
      if (this.newBudget == null || this.newBudget.IdDistributor == null || this.newBudget.Workforce == null || this.newBudget.Workforce == 0)
        this.showProvince = true;

      this.dataform.patchValue(this.newBudget);
    });
  }


  get f() { return this.dataform.controls; }

  loadData() {

    this.sharedService.GetProvince().subscribe(resp => {
      this.provinces = resp;
    }, (err) => {
      Swal.fire({
        toast: true,
        showConfirmButton: false,
        icon: 'error',
        title: '',
        text: 'Error al recuperar los datos'
      });
    });

  }

  saveBudget() {

    this.submitted = 1;

    if (this.dataform.controls.Months.value > 120 || this.dataform.controls.Km.value > 150000) {
      this.showErrorMonthKm();
    }

    if (!this.dataform.valid) return;

    this.newBudget = this.dataform.value;

    if (this.newBudget.Months == null) {
      this.newBudget.Months = 0;
    }

    this.budgetService.put(this.newBudget.IdBudget, this.newBudget).subscribe(res => {

      this.router.navigate(['/budget-preview/' + this.newBudget.IdBudget]);

    }, (err) => {
      Swal.fire({
        toast: true,
        showConfirmButton: false,
        icon: 'error',
        title: '',
        text: 'Error al crear el presupuesto'
      });
    });
  }

  valueKmChange(event) {
    this.dataform.controls.Km.setValue(event);
  }

  changeKmValue(data) {

    if (+data > 150000) {
      this.showErrorMonthKm();
    }
    if (+data > 1000) {
      this.valueKm = +data;
      this.dataform.controls.Km.setValue(this.valueKm);
    }


  }

  showErrorMonthKm() {
    Swal.fire({
      icon: 'info',
      text: 'Queremos cuidar de tu CUPRA como se merece. Te recomendamos que traigas tu vehículo de más de 10 años y/o 150.000 km a tu Servicio Especialista CUPRA y un Asesor de Servicio te indicará con más detalle qué operaciones de mantenimiento y desgaste necesita para seguir rodando con la máxima seguridad.',
      confirmButtonText: 'Cerrar',
    });
  }

}
